const BIBLE_API_BASE = 'https://bible-api.com';
const DOOR43_API_BASE = 'https://git.door43.org/api/v1/repos/unfoldingWord';
const DOOR43_CDN_BASE = 'https://cdn.door43.org';

const BOOK_DATA = [
  ['Genesis', 50, 'GEN', '01', 'ot'], ['Exodus', 40, 'EXO', '02', 'ot'],
  ['Leviticus', 27, 'LEV', '03', 'ot'], ['Numbers', 36, 'NUM', '04', 'ot'],
  ['Deuteronomy', 34, 'DEU', '05', 'ot'], ['Joshua', 24, 'JOS', '06', 'ot'],
  ['Judges', 21, 'JDG', '07', 'ot'], ['Ruth', 4, 'RUT', '08', 'ot'],
  ['1 Samuel', 31, '1SA', '09', 'ot'], ['2 Samuel', 24, '2SA', '10', 'ot'],
  ['1 Kings', 22, '1KI', '11', 'ot'], ['2 Kings', 25, '2KI', '12', 'ot'],
  ['1 Chronicles', 29, '1CH', '13', 'ot'], ['2 Chronicles', 36, '2CH', '14', 'ot'],
  ['Ezra', 10, 'EZR', '15', 'ot'], ['Nehemiah', 13, 'NEH', '16', 'ot'],
  ['Esther', 10, 'EST', '17', 'ot'], ['Job', 42, 'JOB', '18', 'ot'],
  ['Psalms', 150, 'PSA', '19', 'ot'], ['Proverbs', 31, 'PRO', '20', 'ot'],
  ['Ecclesiastes', 12, 'ECC', '21', 'ot'], ['Song of Solomon', 8, 'SNG', '22', 'ot'],
  ['Isaiah', 66, 'ISA', '23', 'ot'], ['Jeremiah', 52, 'JER', '24', 'ot'],
  ['Lamentations', 5, 'LAM', '25', 'ot'], ['Ezekiel', 48, 'EZK', '26', 'ot'],
  ['Daniel', 12, 'DAN', '27', 'ot'], ['Hosea', 14, 'HOS', '28', 'ot'],
  ['Joel', 3, 'JOL', '29', 'ot'], ['Amos', 9, 'AMO', '30', 'ot'],
  ['Obadiah', 1, 'OBA', '31', 'ot'], ['Jonah', 4, 'JON', '32', 'ot'],
  ['Micah', 7, 'MIC', '33', 'ot'], ['Nahum', 3, 'NAM', '34', 'ot'],
  ['Habakkuk', 3, 'HAB', '35', 'ot'], ['Zephaniah', 3, 'ZEP', '36', 'ot'],
  ['Haggai', 2, 'HAG', '37', 'ot'], ['Zechariah', 14, 'ZEC', '38', 'ot'],
  ['Malachi', 4, 'MAL', '39', 'ot'],
  ['Matthew', 28, 'MAT', '41', 'nt'], ['Mark', 16, 'MRK', '42', 'nt'],
  ['Luke', 24, 'LUK', '43', 'nt'], ['John', 21, 'JHN', '44', 'nt'],
  ['Acts', 28, 'ACT', '45', 'nt'], ['Romans', 16, 'ROM', '46', 'nt'],
  ['1 Corinthians', 16, '1CO', '47', 'nt'], ['2 Corinthians', 13, '2CO', '48', 'nt'],
  ['Galatians', 6, 'GAL', '49', 'nt'], ['Ephesians', 6, 'EPH', '50', 'nt'],
  ['Philippians', 4, 'PHP', '51', 'nt'], ['Colossians', 4, 'COL', '52', 'nt'],
  ['1 Thessalonians', 5, '1TH', '53', 'nt'], ['2 Thessalonians', 3, '2TH', '54', 'nt'],
  ['1 Timothy', 6, '1TI', '55', 'nt'], ['2 Timothy', 4, '2TI', '56', 'nt'],
  ['Titus', 3, 'TIT', '57', 'nt'], ['Philemon', 1, 'PHM', '58', 'nt'],
  ['Hebrews', 13, 'HEB', '59', 'nt'], ['James', 5, 'JAS', '60', 'nt'],
  ['1 Peter', 5, '1PE', '61', 'nt'], ['2 Peter', 3, '2PE', '62', 'nt'],
  ['1 John', 5, '1JN', '63', 'nt'], ['2 John', 1, '2JN', '64', 'nt'],
  ['3 John', 1, '3JN', '65', 'nt'], ['Jude', 1, 'JUD', '66', 'nt'],
  ['Revelation', 22, 'REV', '67', 'nt'],
];

const ALL_BIBLE_BOOKS = Object.freeze(
  BOOK_DATA.map(([name, chapters, usfm, number, testament]) =>
    Object.freeze({ name, chapters, usfm, number, testament })
  )
);
const OLD_TESTAMENT_BOOKS = Object.freeze(
  ALL_BIBLE_BOOKS.filter((book) => book.testament === 'ot')
);
const NEW_TESTAMENT_BOOKS = Object.freeze(
  ALL_BIBLE_BOOKS.filter((book) => book.testament === 'nt')
);

export const WEB_BIBLE_BOOKS = ALL_BIBLE_BOOKS;

export const BIBLE_TRANSLATIONS = Object.freeze({
  web: Object.freeze({
    id: 'web',
    shortName: 'WEB',
    name: 'World English Bible',
    language: 'English',
    languageCode: 'en',
    direction: 'ltr',
    scope: 'Old and New Testaments',
    license: 'Public Domain',
    attribution: 'World English Bible',
    licenseUrl: 'https://worldenglish.bible/',
    sourceUrl: 'https://worldenglish.bible/',
    fontFamily: 'Georgia, "Times New Roman", serif',
    books: ALL_BIBLE_BOOKS,
    sourceType: 'bible-api',
  }),
  ugnt: Object.freeze({
    id: 'ugnt',
    shortName: 'UGNT',
    name: 'unfoldingWord Greek New Testament',
    language: 'Koine Greek',
    languageCode: 'grc',
    direction: 'ltr',
    scope: 'New Testament',
    license: 'CC BY-SA 4.0',
    attribution: 'unfoldingWord Greek New Testament v0.34',
    licenseUrl: 'https://creativecommons.org/licenses/by-sa/4.0/',
    sourceUrl: 'https://git.door43.org/unfoldingWord/el-x-koine_ugnt/src/tag/v0.34',
    fontFamily: '"Noto Serif Greek", "Noto Sans Greek", "Gentium Plus", "Palatino Linotype", Georgia, serif',
    books: NEW_TESTAMENT_BOOKS,
    sourceType: 'door43-usfm',
    repo: 'el-x-koine_ugnt',
    version: '0.34',
    dcsRef: 'v0.34',
    cdnLanguage: 'el-x-koine',
    cdnResource: 'ugnt',
  }),
  uhb: Object.freeze({
    id: 'uhb',
    shortName: 'UHB',
    name: 'unfoldingWord Hebrew Bible',
    language: 'Biblical Hebrew',
    languageCode: 'hbo',
    direction: 'rtl',
    scope: 'Old Testament',
    license: 'CC BY-SA 4.0',
    attribution: 'unfoldingWord Hebrew Bible v2.1.32',
    licenseUrl: 'https://creativecommons.org/licenses/by-sa/4.0/',
    sourceUrl: 'https://git.door43.org/unfoldingWord/hbo_uhb/src/tag/v2.1.32',
    fontFamily: '"Noto Serif Hebrew", "Noto Sans Hebrew", "SBL Hebrew", "Ezra SIL", "Times New Roman", serif',
    books: OLD_TESTAMENT_BOOKS,
    sourceType: 'door43-usfm',
    repo: 'hbo_uhb',
    version: '2.1.32',
    dcsRef: 'v2.1.32',
    cdnLanguage: 'hbo',
    cdnResource: 'uhb',
  }),
});

export const BIBLE_PARALLEL_MODES = Object.freeze({
  web: Object.freeze({
    id: 'web',
    name: 'World English Bible',
    shortName: 'English WEB (Free)',
    originalTranslationId: 'web',
    englishTranslationId: null,
    standalone: true,
    books: ALL_BIBLE_BOOKS,
    defaultBook: 'John',
    defaultChapter: 3,
  }),
  nt: Object.freeze({
    id: 'nt',
    name: 'Greek + English New Testament',
    shortName: 'Greek + English NT',
    originalTranslationId: 'ugnt',
    englishTranslationId: 'web',
    books: NEW_TESTAMENT_BOOKS,
    defaultBook: 'John',
    defaultChapter: 3,
  }),
  ot: Object.freeze({
    id: 'ot',
    name: 'Hebrew + English Old Testament',
    shortName: 'Hebrew + English OT',
    originalTranslationId: 'uhb',
    englishTranslationId: 'web',
    books: OLD_TESTAMENT_BOOKS,
    defaultBook: 'Genesis',
    defaultChapter: 1,
  }),
});

export const BIBLE_PARALLEL_MODE_OPTIONS = Object.freeze(
  Object.values(BIBLE_PARALLEL_MODES).map((mode) =>
    Object.freeze({ id: mode.id, name: mode.name, shortName: mode.shortName })
  )
);

export const getParallelBibleMode = (modeId = 'nt') =>
  BIBLE_PARALLEL_MODES[String(modeId || '').toLowerCase()] ||
  BIBLE_PARALLEL_MODES.nt;

export const BIBLE_TRANSLATION_OPTIONS = Object.freeze(
  Object.values(BIBLE_TRANSLATIONS).map((translation) =>
    Object.freeze({
      id: translation.id,
      shortName: translation.shortName,
      name: translation.name,
      language: translation.language,
      scope: translation.scope,
    })
  )
);

export const getBibleTranslation = (translationId = 'web') =>
  BIBLE_TRANSLATIONS[String(translationId || '').toLowerCase()] ||
  BIBLE_TRANSLATIONS.web;

export const getBibleBooks = (translationId = 'web') =>
  getBibleTranslation(translationId).books;

export const buildBibleReference = (book, chapter, verse = '') => {
  const cleanBook = String(book || '').trim();
  const cleanChapter = Number.parseInt(chapter, 10);
  const cleanVerse = verse === '' || verse == null
    ? ''
    : Number.parseInt(verse, 10);

  if (!cleanBook || !Number.isInteger(cleanChapter) || cleanChapter < 1) {
    throw new Error('Choose a valid Bible book and chapter.');
  }
  if (cleanVerse !== '' && (!Number.isInteger(cleanVerse) || cleanVerse < 1)) {
    throw new Error('Choose a valid verse.');
  }
  return `${cleanBook} ${cleanChapter}${cleanVerse === '' ? '' : `:${cleanVerse}`}`;
};

export const normalizeBibleResponse = (payload = {}, overrides = {}) => {
  const verses = Array.isArray(payload.verses)
    ? payload.verses
        .map((item) => ({
          book: String(item?.book_name || item?.book || '').trim(),
          chapter: Number(item?.chapter),
          verse: Number(item?.verse),
          text: String(item?.text || '').replace(/\s+/g, ' ').trim(),
        }))
        .filter(
          (item) =>
            item.book &&
            Number.isFinite(item.chapter) &&
            Number.isFinite(item.verse) &&
            item.text
        )
    : [];

  if (!verses.length) {
    throw new Error(payload?.error || 'No verses were returned for this reference.');
  }

  return {
    reference: String(overrides.reference || payload.reference || '').trim(),
    translationName:
      String(overrides.translationName || payload.translation_name || '').trim() ||
      'World English Bible',
    translationId:
      String(overrides.translationId || payload.translation_id || '').trim() || 'web',
    shortName: String(overrides.shortName || payload.translation_id || 'WEB').toUpperCase(),
    language: String(overrides.language || 'English'),
    languageCode: String(overrides.languageCode || 'en'),
    direction: overrides.direction === 'rtl' ? 'rtl' : 'ltr',
    license: String(overrides.license || 'Public Domain'),
    attribution: String(overrides.attribution || 'World English Bible'),
    licenseUrl: String(overrides.licenseUrl || ''),
    sourceUrl: String(overrides.sourceUrl || ''),
    fontFamily: String(overrides.fontFamily || 'Georgia, "Times New Roman", serif'),
    verses,
  };
};

const chapterCache = new Map();
const bookSourceCache = new Map();

const decodeBase64Utf8 = (value) => {
  const compact = String(value || '').replace(/\s+/g, '');
  if (!compact) return '';

  if (typeof Buffer !== 'undefined') {
    return Buffer.from(compact, 'base64').toString('utf8');
  }

  const binary = globalThis.atob(compact);
  const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
  if (typeof TextDecoder !== 'undefined') {
    return new TextDecoder('utf-8').decode(bytes);
  }

  let encoded = '';
  bytes.forEach((byte) => { encoded += `%${byte.toString(16).padStart(2, '0')}`; });
  return decodeURIComponent(encoded);
};

const looksLikeBlockedHtml = (value) => {
  const sample = String(value || '').slice(0, 1000).toLowerCase();
  return sample.includes('<!doctype html') ||
    sample.includes('<html') ||
    sample.includes('access denied') ||
    sample.includes('protected by anubis');
};

const fetchText = async (url, { signal, expectJson = false } = {}) => {
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Accept: expectJson ? 'application/json' : 'text/plain, text/usfm, */*',
    },
    signal,
  });

  if (!response.ok) {
    throw new Error(`Scripture source returned ${response.status}.`);
  }

  if (expectJson) {
    const payload = await response.json().catch(() => ({}));
    if (payload?.content) {
      const decoded = String(payload.encoding || '').toLowerCase() === 'base64'
        ? decodeBase64Utf8(payload.content)
        : String(payload.content);
      if (!decoded || looksLikeBlockedHtml(decoded)) {
        throw new Error('Scripture source returned an invalid document.');
      }
      return decoded;
    }
    if (payload?.download_url) {
      return fetchText(payload.download_url, { signal });
    }
    throw new Error(payload?.message || 'Scripture source did not include file content.');
  }

  const text = await response.text();
  if (!text || looksLikeBlockedHtml(text)) {
    throw new Error('Scripture source returned an invalid document.');
  }
  return text;
};

const fetchDoor43Book = async (translation, bookInfo, { signal } = {}) => {
  const sourceKey = `${translation.id}:${bookInfo.usfm}`;
  if (bookSourceCache.has(sourceKey)) return bookSourceCache.get(sourceKey);

  const fileName = `${bookInfo.number}-${bookInfo.usfm}.usfm`;
  const versionPath = `v${String(translation.version).replace(/^v/i, '')}`;
  const candidates = [
    {
      url: `${DOOR43_CDN_BASE}/${translation.cdnLanguage}/${translation.cdnResource}/${versionPath}/${bookInfo.usfm.toLowerCase()}.usfm`,
      expectJson: false,
    },
    {
      url: `${DOOR43_CDN_BASE}/${translation.cdnLanguage}/${translation.cdnResource}/${versionPath}/${fileName}`,
      expectJson: false,
    },
    {
      url: `${DOOR43_API_BASE}/${translation.repo}/contents/${fileName}?ref=${encodeURIComponent(translation.dcsRef)}`,
      expectJson: true,
    },
    {
      url: `${DOOR43_API_BASE}/${translation.repo}/raw/${fileName}?ref=${encodeURIComponent(translation.dcsRef)}`,
      expectJson: false,
    },
    {
      url: `https://git.door43.org/unfoldingWord/${translation.repo}/raw/tag/${translation.dcsRef}/${fileName}`,
      expectJson: false,
    },
  ];

  let lastError = null;
  for (const candidate of candidates) {
    try {
      const usfm = await fetchText(candidate.url, {
        signal,
        expectJson: candidate.expectJson,
      });
      if (!/\\id\s+/i.test(usfm) && !/\\c\s+\d+/i.test(usfm)) {
        throw new Error('Scripture source is not a valid USFM document.');
      }
      bookSourceCache.set(sourceKey, usfm);
      return usfm;
    } catch (error) {
      if (error?.name === 'AbortError') throw error;
      lastError = error;
    }
  }

  throw new Error(
    lastError?.message ||
      `${translation.shortName} could not be loaded from the free Scripture source.`
  );
};

const removeUsfmNotes = (value) => String(value || '')
  .replace(/\\f\s[\s\S]*?\\f\*/gi, ' ')
  .replace(/\\fe\s[\s\S]*?\\fe\*/gi, ' ')
  .replace(/\\x\s[\s\S]*?\\x\*/gi, ' ');

export const stripUsfmText = (value) => {
  let text = removeUsfmNotes(value);

  // Preserve displayed words while removing lexical/morphology attributes.
  text = text.replace(
    /\\\+?w\s+([^|\\]*?)(?:\|[^\\]*?)?\\\+?w\*/gi,
    (_, word) => word
  );

  // Remove alignment/keyword milestones and their attributes.
  text = text
    .replace(/\\(?:zaln-s|k-s)\b[^\\]*?\\\*/gi, ' ')
    .replace(/\\(?:zaln-e|k-e)\\\*/gi, ' ')
    .replace(/\\ts\\\*/gi, ' ')
    .replace(/\\(?:ca|va|vp)\s+[^\\]*?\\(?:ca|va|vp)\*/gi, ' ');

  // Character-style markers retain the text between their opening/closing tags.
  text = text
    .replace(/\\\+?(?:add|bd|bdit|bk|dc|em|it|k|nd|ord|pn|qt|sc|sig|sls|tl|wj)\*/gi, ' ')
    .replace(/\\\+?(?:add|bd|bdit|bk|dc|em|it|k|nd|ord|pn|qt|sc|sig|sls|tl|wj)\s+/gi, ' ');

  // Remove remaining paragraph, poetry, heading and metadata markers.
  text = text
    .replace(/\\[a-z][a-z0-9-]*\*?/gi, ' ')
    .replace(/\|[a-z][\w-]*=(?:"[^"]*"|'[^']*'|[^\s|]+)/gi, ' ')
    .replace(/[\u2060\u200e\u200f]/g, '')
    .replace(/\s+([,.;:!?·׃׀])/g, '$1')
    .replace(/([\[(])\s+/g, '$1')
    .replace(/\s+([\])])/g, '$1')
    .replace(/\s+/g, ' ')
    .trim();

  return text.normalize ? text.normalize('NFC') : text;
};

export const parseUsfmChapter = (
  usfm,
  { translationId = 'web', book, chapter } = {}
) => {
  const translation = getBibleTranslation(translationId);
  const bookInfo = translation.books.find((item) => item.name === book);
  const targetChapter = Number.parseInt(chapter, 10);
  if (!bookInfo || !Number.isInteger(targetChapter) || targetChapter < 1) {
    throw new Error('Choose a valid book and chapter for this Bible.');
  }

  const source = String(usfm || '').replace(/\r\n?/g, '\n');
  const tokenPattern = /\\c\s+(\d+)|\\v\s+(\d+(?:[-–]\d+)?[a-z]?)/gi;
  const verses = [];
  let currentChapter = 0;
  let activeVerseToken = '';
  let segmentStart = 0;
  let match;

  const flushVerse = (segmentEnd) => {
    if (!activeVerseToken || currentChapter !== targetChapter) return;
    const text = stripUsfmText(source.slice(segmentStart, segmentEnd));
    if (!text) return;
    const verseNumber = Number.parseInt(activeVerseToken, 10);
    if (!Number.isFinite(verseNumber)) return;
    verses.push({
      book: bookInfo.name,
      chapter: targetChapter,
      verse: verseNumber,
      verseLabel: activeVerseToken,
      text,
    });
  };

  while ((match = tokenPattern.exec(source)) !== null) {
    flushVerse(match.index);
    if (match[1]) {
      currentChapter = Number.parseInt(match[1], 10);
      activeVerseToken = '';
    } else {
      activeVerseToken = match[2];
    }
    segmentStart = tokenPattern.lastIndex;
  }
  flushVerse(source.length);

  if (!verses.length) {
    throw new Error(`${translation.shortName} ${bookInfo.name} ${targetChapter} has no readable verses.`);
  }

  return {
    reference: `${bookInfo.name} ${targetChapter}`,
    translationName: translation.name,
    translationId: translation.id,
    shortName: translation.shortName,
    language: translation.language,
    languageCode: translation.languageCode,
    direction: translation.direction,
    license: translation.license,
    attribution: translation.attribution,
    licenseUrl: translation.licenseUrl,
    sourceUrl: translation.sourceUrl,
    fontFamily: translation.fontFamily,
    verses,
  };
};

const fetchWebChapter = async (book, chapter, { signal } = {}) => {
  const reference = buildBibleReference(book, chapter);
  const response = await fetch(
    `${BIBLE_API_BASE}/${encodeURIComponent(reference)}?translation=web&single_chapter_book_matching=indifferent`,
    {
      method: 'GET',
      headers: { Accept: 'application/json' },
      signal,
    }
  );

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.error || `Bible service returned ${response.status}.`);
  }

  const translation = BIBLE_TRANSLATIONS.web;
  return normalizeBibleResponse(payload, {
    reference,
    translationName: translation.name,
    translationId: translation.id,
    shortName: translation.shortName,
    language: translation.language,
    languageCode: translation.languageCode,
    direction: translation.direction,
    license: translation.license,
    attribution: translation.attribution,
    licenseUrl: translation.licenseUrl,
    sourceUrl: translation.sourceUrl,
    fontFamily: translation.fontFamily,
  });
};

export const fetchBibleChapter = async (
  translationId,
  book,
  chapter,
  { signal } = {}
) => {
  const translation = getBibleTranslation(translationId);
  const bookInfo = translation.books.find((item) => item.name === String(book || '').trim());
  const chapterNumber = Number.parseInt(chapter, 10);

  if (!bookInfo || !Number.isInteger(chapterNumber) || chapterNumber < 1 || chapterNumber > bookInfo.chapters) {
    throw new Error('Choose a valid book and chapter for this Bible.');
  }

  const cacheKey = `${translation.id}:${bookInfo.usfm}:${chapterNumber}`;
  if (chapterCache.has(cacheKey)) return chapterCache.get(cacheKey);

  const result = translation.sourceType === 'bible-api'
    ? await fetchWebChapter(bookInfo.name, chapterNumber, { signal })
    : parseUsfmChapter(
        await fetchDoor43Book(translation, bookInfo, { signal }),
        {
          translationId: translation.id,
          book: bookInfo.name,
          chapter: chapterNumber,
        }
      );

  chapterCache.set(cacheKey, result);
  return result;
};

export const fetchWebBibleChapter = async (book, chapter, options = {}) =>
  fetchBibleChapter('web', book, chapter, options);

const mergeVerseParts = (verses = []) => {
  const indexed = new Map();
  verses.forEach((item) => {
    const verseNumber = Number(item?.verse);
    const text = String(item?.text || '').trim();
    if (!Number.isFinite(verseNumber) || !text) return;

    const current = indexed.get(verseNumber);
    if (!current) {
      indexed.set(verseNumber, { ...item, verse: verseNumber, text });
      return;
    }

    indexed.set(verseNumber, {
      ...current,
      verseLabel: current.verseLabel || item.verseLabel || String(verseNumber),
      text: `${current.text} ${text}`.replace(/\s+/g, ' ').trim(),
    });
  });
  return indexed;
};

/**
 * Aligns an original-language and English chapter by canonical verse number.
 * A row is retained when either source contains the verse, so a source-specific
 * numbering gap is visible instead of silently shifting the text.
 */
export const alignBibleChapterVerses = (originalChapter, englishChapter) => {
  const originalByVerse = mergeVerseParts(originalChapter?.verses);
  const englishByVerse = mergeVerseParts(englishChapter?.verses);
  const verseNumbers = Array.from(
    new Set([...originalByVerse.keys(), ...englishByVerse.keys()])
  ).sort((left, right) => left - right);

  return verseNumbers.map((verseNumber) => {
    const original = originalByVerse.get(verseNumber) || null;
    const english = englishByVerse.get(verseNumber) || null;
    const sample = original || english;
    const book = String(sample?.book || '').trim();
    const chapter = Number(sample?.chapter);
    return {
      book,
      chapter,
      verse: verseNumber,
      verseLabel:
        original?.verseLabel || english?.verseLabel || String(verseNumber),
      reference: buildBibleReference(book, chapter, verseNumber),
      original,
      english,
    };
  });
};

export const mapStandaloneBibleChapterVerses = (chapterData) => {
  const versesByNumber = mergeVerseParts(chapterData?.verses);
  return Array.from(versesByNumber.keys())
    .sort((left, right) => left - right)
    .map((verseNumber) => {
      const original = versesByNumber.get(verseNumber);
      const book = String(original?.book || '').trim();
      const chapter = Number(original?.chapter);
      return {
        book,
        chapter,
        verse: verseNumber,
        verseLabel: original?.verseLabel || String(verseNumber),
        reference: buildBibleReference(book, chapter, verseNumber),
        original,
        english: null,
      };
    });
};

const pickTranslationMetadata = (chapter) => ({
  id: chapter.translationId,
  shortName: chapter.shortName,
  name: chapter.translationName,
  language: chapter.language,
  languageCode: chapter.languageCode,
  direction: chapter.direction,
  license: chapter.license,
  licenseUrl: chapter.licenseUrl,
  attribution: chapter.attribution,
  sourceUrl: chapter.sourceUrl,
});

export const fetchParallelBibleChapter = async (
  modeId,
  book,
  chapter,
  { signal } = {}
) => {
  const mode = getParallelBibleMode(modeId);
  const bookInfo = mode.books.find((item) => item.name === String(book || '').trim());
  const chapterNumber = Number.parseInt(chapter, 10);

  if (
    !bookInfo ||
    !Number.isInteger(chapterNumber) ||
    chapterNumber < 1 ||
    chapterNumber > bookInfo.chapters
  ) {
    throw new Error('Choose a valid book and chapter for this parallel Bible.');
  }

  const [original, english] = mode.standalone
    ? [
        await fetchBibleChapter(
          mode.originalTranslationId,
          bookInfo.name,
          chapterNumber,
          { signal }
        ),
        null,
      ]
    : await Promise.all([
        fetchBibleChapter(
          mode.originalTranslationId,
          bookInfo.name,
          chapterNumber,
          { signal }
        ),
        fetchBibleChapter(
          mode.englishTranslationId,
          bookInfo.name,
          chapterNumber,
          { signal }
        ),
      ]);
  const verses = mode.standalone
    ? mapStandaloneBibleChapterVerses(original)
    : alignBibleChapterVerses(original, english);
  if (!verses.length) {
    throw new Error(`No Bible verses were returned for ${bookInfo.name} ${chapterNumber}.`);
  }

  return {
    modeId: mode.id,
    modeName: mode.name,
    book: bookInfo.name,
    chapter: chapterNumber,
    reference: buildBibleReference(bookInfo.name, chapterNumber),
    original,
    english,
    translations: [
      pickTranslationMetadata(original),
      ...(english ? [pickTranslationMetadata(english)] : []),
    ],
    verses,
  };
};

const buildScriptureInsertId = () => {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  return `scripture-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
};

const formatSourceLine = (translation) =>
  `${translation.attribution} — ${translation.license}`;

/**
 * Creates the clean event/callback contract consumed by ClassBlackboard.
 * The composed text intentionally includes reference, translation and licence
 * attribution so copied board content remains correctly attributed.
 */
export const buildBlackboardScripturePayload = (
  chapterData,
  { verse = null, mode = 'text' } = {}
) => {
  if (!chapterData?.verses?.length || !chapterData?.translations?.length) {
    throw new Error('Load a Bible passage before inserting it.');
  }
  if (!['text', 'sticky'].includes(mode)) {
    throw new Error('Blackboard Bible insertion mode must be text or sticky.');
  }

  const requestedVerse = verse === '' || verse == null ? null : Number(verse);
  const rows = requestedVerse == null
    ? chapterData.verses
    : chapterData.verses.filter((item) => item.verse === requestedVerse);
  if (!rows.length) throw new Error('Choose an available Bible verse.');

  const scope = requestedVerse == null ? 'chapter' : 'verse';
  const reference = scope === 'verse'
    ? buildBibleReference(chapterData.book, chapterData.chapter, requestedVerse)
    : buildBibleReference(chapterData.book, chapterData.chapter);
  const [originalMeta, englishMeta] = chapterData.translations;
  const standalone = !englishMeta;
  const originalText = rows
    .filter((row) => row.original?.text)
    .map((row) => `${row.verseLabel || row.verse}. ${row.original.text}`)
    .join('\n');
  const englishText = standalone ? '' : rows
    .filter((row) => row.english?.text)
    .map((row) => `${row.verseLabel || row.verse}. ${row.english.text}`)
    .join('\n');

  const translations = [
    { ...originalMeta, text: originalText },
    ...(standalone ? [] : [{ ...englishMeta, text: englishText }]),
  ];
  const rowText = rows.map((row) => [
    scope === 'chapter' ? `Verse ${row.verseLabel || row.verse}` : null,
    row.original?.text
      ? `${originalMeta.shortName} (${originalMeta.language}): ${row.original.text}`
      : `${originalMeta.shortName}: [Verse not available in this source]`,
    !standalone && row.english?.text
      ? `${englishMeta.shortName} (${englishMeta.language}): ${row.english.text}`
      : !standalone
        ? `${englishMeta.shortName}: [Verse not available in this source]`
        : null,
  ].filter(Boolean).join('\n')).join('\n\n');
  const attribution = translations.map(formatSourceLine).join('\n');

  return {
    id: buildScriptureInsertId(),
    mode,
    scope,
    reference,
    translations,
    text: `${reference}\n\n${rowText}\n\nSources:\n${attribution}`,
  };
};
